// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__ynAgG","pink":"About_pink__lm0Ai","green":"About_green__fLIdZ","skills":"About_skills__kjgiL"};